var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueSlider',{attrs:{"tooltip":'none',"process-style":{ backgroundColor: 'pink' },"tooltip-style":{ backgroundColor: 'pink', borderColor: 'pink' }},scopedSlots:_vm._u([{key:"dot",fn:function(ref){
var value = ref.value;
var focus = ref.focus;
return [_c('div',{class:['custom-dot', { focus: focus }]})]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }